import { LoadingStatusType } from "@/enums/enums";
import API from "@/service/Index";
import { ConvertToMerchantDetail } from "@/service/merchant/merchantFacade";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Setting extends VuexModule {
  private merchantDetailLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  private merchantDetail: any = null;

  get getMerchantDetailLoadingStatus(): LoadingStatusType {
    return this.merchantDetailLoadingStatus;
  }

  get getMerchantDetail(): any {
    return this.merchantDetail;
  }

  @Mutation
  public MutationMerchantDetailLoadingStatus(status: LoadingStatusType) {
    this.merchantDetailLoadingStatus = status;
  }

  @Mutation
  public MutationMerchantDetail(merchantDetail: any) {
    this.merchantDetail = merchantDetail;
  }

  @Action DoGetMerchantDetail() {
    if (this.merchantDetailLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Loading);
      API.MerchantService.GetMerchantDetail().then((resMerchantDetail: any) => {
        if (resMerchantDetail.status.IsSuccess()) {
          const detail = ConvertToMerchantDetail(resMerchantDetail.data.detail);
          this.context.commit("MutationMerchantDetail", detail);
        }
        this.context.commit("MutationMerchantDetailLoadingStatus", LoadingStatusType.Success);
        this.context.dispatch("Loading/IsLoading", false, { root: true });
      });
    }
  }
}
